module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#trending",
      toString: function () {
        return this.url;
      }
    }